import * as React from 'react';
import { BpDesignSystem } from '../../types';
import { type DateTimeFormatterV2Options, type DateTypesV2, useDateTimeFormatterV2 } from '../../utils/dateFormatters';
import { Box } from '../Box/Box';

export type DateTimeFormatterV2Props = BpDesignSystem.Props<
  DateTimeFormatterV2Options & {
    date?: DateTypesV2;
    id?: string;
    div?: WrapDateInDiv;
  }
>;

type WrapDateInDiv = boolean;

/**
 * Simple wrapper around the useDateTimeFormatterV2 hook. Allows hook
 * be used like a React component supporting all the same properties.
 *
 * For example:
 *
 * @example
 * <DateTimeFormatterV2
 *  date={date}
 *  utc
 *  time
 *  timeZone
 *  numberMonth={false}
 *  format={{
 *    MONTH: MONTH_FORMAT.LONG
 *  }} />
 *
 */
export const DateTimeFormatterV2: React.FC<DateTimeFormatterV2Props> = ({
  dataTest,
  style,
  sx,
  date,
  id,
  className,
  div,
  ...props
}) => {
  const dateTimeFormatter = useDateTimeFormatterV2();
  const formattedDate = dateTimeFormatter(date, { ...props });

  return (
    <Box component={div ? 'div' : 'span'} dataTest={dataTest} id={id} className={className} style={style} sx={sx}>
      {formattedDate}
    </Box>
  );
};
